export default "__VITE_ASSET__YPOAXaOw__"